import {ErrorHandler, Injectable} from '@angular/core';
import {SessaoService} from '../sessao/sessao.service';
import {HttpErrorResponse} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {MensageriaService} from '@main-class/componentes/core';

@Injectable({
  providedIn: 'root'
})
export class MensagemErrorHandlerService implements ErrorHandler {

  constructor(
    private mensageria: MensageriaService,
    private sessao: SessaoService,
    private translateService: TranslateService,
  ) {
  }

  handleError(error: any): void {
    const cause = error.rejection || error;
    if (cause instanceof HttpErrorResponse) {
      const actions = {
        400: (dto) => this.badRequest(dto),
        403: () => {
          this.sessao.logout();
        },
        401: () => {
          this.sessao.logout();
        },
        501: () => this.mensageria.addMensagem('erro.mensagem.MSG-501', {}, 'OK', {
          duration: 5000,
        }),
        502: () => this.mensageria.addMensagem('erro.mensagem.MSG-502', {}, 'OK', {
          duration: 5000,
        }),
        503: () => this.mensageria.addMensagem('erro.mensagem.MSG-502', {}, 'OK', {
          duration: 5000,
        }),
        504: () => this.mensageria.addMensagem('erro.mensagem.MSG-502', {}, 'OK', {
          duration: 5000,
        }),
      };

      if (cause.status) {
        const action = actions[cause.status];
        if (action) {
          action(cause.error);
          return;
        }
      }
    }

    console.error(error);

    this.mensageria.addMensagem('erro.mensagem.MSG-500', {}, 'OK', {
      duration: 5000,
    });
  }

  private badRequest(erro: any) {
    if (erro.codigo) {
      const messageKey = 'erro.mensagem.backend.MSG-' + erro.codigo;

      if (this.translateService.instant(messageKey, erro.parametros as any) === messageKey) {
        if (erro.mensagem) {
          this.mensageria.addMensagem(erro.mensagem, erro.parametros as any, 'OK', {
            duration: 5000,
          });
        } else {
          console.warn('Retorno do servidor sem mensagem registrada: ', erro);

          this.mensageria.addMensagem('erro.mensagem.MSG-500', {}, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.mensageria.addMensagem(
          messageKey, erro.parametros as any, 'OK', {
            duration: 5000,
          }
        );
      }
    } else {
      console.error(erro);

      this.mensageria.addMensagem('erro.mensagem.MSG-500', {}, 'OK', {
        duration: 5000,
      });
    }
  }
}
